import { CompactEncrypt, compactDecrypt } from "jose";
const te = new TextEncoder();
const td = new TextDecoder();

function b64urlToBytes(b64url) {
  const padLen = (4 - (b64url.length % 4)) % 4;
  const padded =
    b64url.replace(/-/g, "+").replace(/_/g, "/") + "=".repeat(padLen);
  if (typeof Buffer !== "undefined")
    return Uint8Array.from(Buffer.from(padded, "base64"));
  const bin = atob(padded);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}
export function importA256GCMKeyFromB64Url(b64urlKey) {
  const keyBytes = b64urlToBytes(b64urlKey);
  if (keyBytes.length !== 32)
    throw new Error("Encryption key must be 32 bytes.");
  return keyBytes;
}

export async function encryptJSON(payload, b64urlKey, kid) {
  const key = importA256GCMKeyFromB64Url(b64urlKey);
  const plaintext = te.encode(JSON.stringify(payload));
  return await new CompactEncrypt(plaintext)
    .setProtectedHeader({
      alg: "dir",
      enc: "A256GCM",
      typ: "JWE",
      ...(kid ? { kid } : {}),
    })
    .encrypt(key);
}

export async function decryptJSON(token, b64urlKey) {
  const key = importA256GCMKeyFromB64Url(b64urlKey);
  const { plaintext } = await compactDecrypt(token, key);
  return JSON.parse(td.decode(plaintext));
}
